/**
 * El alcance por local de un usuario.
 *
 * REGLA, y no se afloja: un alcance VACÍO significa CERO locales, nunca TODOS.
 *
 * De dónde sale la regla: un empleado con `assignedWarehouses` en null —un dato
 * que el dueño nunca cargó— hacía que el front pidiera los locales con
 * `id _in []`. El BFF DESCARTA los filtros con lista vacía (`Criteria::any_of`,
 * y tiene un test que lo dice: `any_of_empty_vec_is_skipped`), así que la
 * respuesta volvía con todos los locales del negocio. El empleado los veía
 * todos y después la pantalla reventaba al entrar a uno.
 *
 * Por eso la decisión vive acá, en una función con nombre y con test, y no
 * suelta adentro de cada hook: si el alcance está vacío, la query NI SE PIDE.
 */
export function hasEmptyWarehouseScope({
  userType,
  assignedWarehouses,
  limitWarehouses,
}: {
  userType: string | undefined;
  assignedWarehouses: unknown;
  limitWarehouses: boolean;
}): boolean {
  // El owner ve todo el negocio por definición: no tiene alcance que limitar.
  if (userType === "owner") return false;

  // La pantalla no pidió limitar por local (ej. el ticket, que necesita
  // resolver la dirección de CUALQUIER local): no es asunto de esta regla.
  if (!limitWarehouses) return false;

  // null, undefined, [] y cualquier cosa que no sea un array con elementos
  // son todos el mismo caso: no tiene ni un local.
  return !Array.isArray(assignedWarehouses) || assignedWarehouses.length === 0;
}
